import React from "react";
import { categories } from "../data/wholesaleProducts";
const money = (n) => `$${n.toFixed(2)}`;
export default function Product({
  items,
  category,
  setCategory,
  sort,
  setSort,
  openProduct,
}) {
  return (
    <main className="shop-page">
      <header className="shop-intro">
        <small>
          THE DELMORIAN COLLECTION / {String(items.length).padStart(2, "0")}
        </small>
        <h1>{category === "All" ? "Care for every chapter." : category}</h1>
        <p>
          Purposeful essentials, clear ingredients and softly joyful design.
        </p>
      </header>
      <div className="catalog-tools mx-auto max-w-content">
        <div>
          {categories.map((x) => (
            <button
              className={category === x ? "active" : ""}
              onClick={() => setCategory(x)}
              key={x}
            >
              {x}
            </button>
          ))}
        </div>
        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="featured">Featured</option>
          <option value="new">Newest</option>
          <option value="low">Price: low</option>
          <option value="high">Price: high</option>
        </select>
      </div>
      <div className="catalog-grid mx-auto max-w-content">
        {items.map((x, i) => (
          <ProductCard
            key={x.id}
            item={x}
            openProduct={openProduct}
            index={i}
          />
        ))}
      </div>
    </main>
  );
}
export function ProductCard({ item, openProduct, index = 0 }) {
  return (
    <article
      className={`product-card card-${index % 4}`}
      onClick={() => openProduct(item)}
    >
      <div className="card-image">
        <img src={item.images[0]} alt={item.title} />
        {item.badge && <span>{item.badge}</span>}
        <button aria-label={`View ${item.title}`}>↗</button>
      </div>
      <small>
        {item.category} · {item.sizes[0]}
      </small>
      <h3>{item.title}</h3>
      <p>{item.summary}</p>
      <b>{money(item.price)}</b>
    </article>
  );
}
